<template>
  <div v-show="authStore.googleClientId">
    <h2
      class="subtitle"
      style="margin-bottom: 0.4em"
    >
      Use Google to sign up or login
    </h2>
    <div id="google-signin-button"></div>
    <hr />
  </div>
</template>

<script
  lang="ts"
  setup
>
import { onMounted, ref, watch } from "vue"
import { useAuthStore } from "../authStore"

const authStore = useAuthStore()

onMounted(() => {
  if (authStore.googleClientId) {
    renderButton()
  }
})

watch(() => authStore.googleClientId, () => {
  renderButton()
})

function onSignIn(response: any) {
  authStore.googleLogin(response.credential)
}

const tries = ref(0)
function renderButton() {
  tries.value++
  // @ts-ignore
  if (window.google) {
    // @ts-ignore
    window.google.accounts.id.initialize({
      client_id: authStore.googleClientId,
      callback: onSignIn
    })
    // @ts-ignore
    window.google.accounts.id.renderButton(document.getElementById("google-signin-button"), { type: 'standard' })
  } else if (tries.value > 5) {
    return
  } else {
    setTimeout(renderButton, 200)
  }
}
</script>
